import { createSlice } from "@reduxjs/toolkit";
import { TabSliceProps } from "../types";

const initialState: TabSliceProps = {
  currentTab: 0,
  childTabIndex: 0,
};

const tabReducer = createSlice({
  name: "tab",
  initialState: initialState,
  reducers: {
    setCurrentTab(state, action) {
      return {
        ...state,
        currentTab: action.payload.currentTab,
        childTabIndex: action.payload.childTabIndex,
      };
    },
    resetTab(state) {
      state.currentTab = 0;
      state.childTabIndex = 0;
    },
  },
});

export default tabReducer.reducer;

export const { setCurrentTab, resetTab } = tabReducer.actions;
